var _rect, _path, _path2, _path3, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 8.95254L5.33334 23.0478C5.33334 24.3101 6.35669 25.3335 7.61905 25.3335L24.3806 25.3335C25.643 25.3335 26.6663 24.3101 26.6663 23.0478L26.6663 8.95254C26.6663 7.69018 25.643 6.66683 24.3806 6.66683L7.61905 6.66683C6.35668 6.66683 5.33334 7.69018 5.33334 8.95254Z",
    fill: "#6B57FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66683L16 25.3335L24.381 25.3335C25.6433 25.3335 26.6667 24.3101 26.6667 23.0478L26.6667 8.95255C26.6667 7.69018 25.6433 6.66683 24.3809 6.66683L16 6.66683Z",
    fill: "#FF7A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5819 12.032C14.1207 11.3537 13.1164 11.3677 12.6743 12.0585L8.15218 19.1243C7.66533 19.885 8.21163 20.8833 9.11477 20.8833H18.4416C18.4486 20.8833 18.4556 20.8832 18.4626 20.8831H22.8905C23.8228 20.8831 24.3629 19.8269 23.817 19.0711L20.7046 14.7617C20.2484 14.1301 19.3078 14.1301 18.8516 14.7617L17.6086 16.4829L14.5819 12.032Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19179_2102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3.33317L16 28.6665L18.6667 28.6665L18.6667 3.33317L16 3.33317Z",
    fill: "url(#paint0_linear_19179_2102)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.166667,
    y: 0.166667,
    width: 31.6667,
    height: 31.6667,
    rx: 7.83333,
    stroke: "#D3D2D6",
    strokeOpacity: 0.2,
    strokeWidth: 0.333333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19179_2102",
    x: 14.6667,
    y: 3.33301,
    width: 4,
    height: 25.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.733333 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19179_2102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19179_2102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19179_2102",
    x1: 16,
    y1: 15.9998,
    x2: 18.6667,
    y2: 15.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeIcon);
export default __webpack_public_path__ + "static/media/pe-icon.61b2e493.svg";
export { ForwardRef as ReactComponent };